module.exports = __webpack_public_path__ + "img/tab_shouye_low.e321c9bd.png";